import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ProjectService {

	statusFilter = 'active';
	invoiceStatusFilter = 'all';
	poStatusFilter = 'all';
	selectedPanelTab = 'tree'; // Default tab for project product log
	showArchived = false;
	labelFilter = [];
	customerFilter = [];

	constructor() { }

}
